export enum NavLocation {
  Info,
  Places
}
